var _excluded = ["svgRef"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#A6A6A6;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 36,
  height: 36
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4,5.7c0.2,1.5-0.8,2.9-2.3,3.2c-1.5,0.2-2.9-0.8-3.2-2.3c-0.2-1.5,0.8-2.9,2.3-3.2C16.7,3.2,18.1,4.2,18.4,5.7z  M17.5,16.6l2.4,3.9c0.3,0.5,1.1,0.7,1.6,0.4c0.6-0.3,0.8-1,0.4-1.6l-0.6-1.1c-0.5-1-1.1-1.9-1.6-2.9l-1.1-2 c-0.1-0.2-0.2-0.5-0.4-0.8c-0.7-1.4-1.7-3.6-4-3.4c-2,0.2-3.9,1.1-5.9,2.8c-2.3,1.8-3.9,4.5-4,4.6c-0.1,0.1-0.1,0.2-0.2,0.3 c0,0,0,0,0,0v0c-0.2,0.4-0.3,0.8-0.1,1.3c0.2,0.4,0.6,0.6,1,0.6c0.5,0,0.8-0.2,1-0.6l0,0c0,0,0,0,0,0c0.1-0.1,0.1-0.2,0.2-0.3 c0,0,1.4-2.2,3.5-4c0.6-0.5,1.3-0.9,1.8-1l-0.5,5.7c0,0.6-0.2,1.5-0.4,2.1l-1.1,3.7c-0.1,0.5-0.5,1.2-0.8,1.6l-2.8,3.5 c-0.4,0.4-0.8,1-0.4,1.7c0.2,0.4,0.6,0.7,1.1,0.7c0.6,0,0.8-0.3,1.2-0.7l2.9-3.1c0.5-0.6,1.2-1.5,1.5-2.2l1.4-2.9l5.3,8.9 c0.3,0.4,0.6,1,1.3,1l0,0c0.4,0,0.8-0.2,1-0.6c0.4-0.6,0.1-1.1-0.1-1.6l-4.3-9.3c-0.2-0.4-0.3-1.1-0.2-1.5L17.5,16.6z M22,26.3h6.4 v1.9l6.4-3.7l-6.4-3.7v1.9H22V26.3z"
});

var SvgRfg = function SvgRfg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRfg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rfg.efd3f2de.svg";
export { ForwardRef as ReactComponent };